export function generateUniqueTicketNumber(): string {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numbers = '0123456789'
  const timestamp = Date.now().toString(36)
  const ticketParts: string[] = []
  for (let i = 0; i < 5; i++) {
    const randomLetter = letters[Math.floor(Math.random() * letters.length)]
    const randomNumber = numbers[Math.floor(Math.random() * numbers.length)]
    ticketParts.push(randomLetter + randomNumber)
  }
  const ticketNumber = ticketParts.join('')
  const hash = timestamp.slice(-2).toUpperCase()
  const formattedTicket = `${ticketNumber}-${hash}`
  return formattedTicket
}
